<template>
  <div>
    <div class="content-panel__header">
      <h2> New Session  </h2>
    </div>
    <p>Here we'll have a validated form to create new sessions (You'll have to wait for the next post)</p>
  </div>
</template>

<script>

  export default {
    name: 'session',
  };
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// Session.vue?4f651a50